import Vue from 'vue';
import ElementUI from 'element-ui';
import '@sweet/element-theme-sweet/dist/index.css';

Vue.use(ElementUI, {
  // size: 'small',
  size: 'medium',
});

export default ElementUI;
